import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1n": "#000000",
    "col2n": "#C40000"
}
function FacNos002({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M35.6.15Q35.35 0 35.15 0q-.15 0-.3.1 0 .048.05.05H2.1Q1.9 0 1.75 0q-.3 0-.5.2Q0 1.35 0 3.05q-.05 1.7 1.65 3.25Q3.2 7.75 5.5 7.75h.05q2.7-.05 4.55-1.5.25-.2.6-.5.15.4.45.8h-.05q.6.9 1.75 1.75 2.3 1.75 5.6 1.75t5.65-1.7l.05-.05q1.5-1.15 2.05-2.55.35.3.6.5 1.8 1.45 4.55 1.5 2.3 0 3.9-1.45 1.65-1.55 1.6-3.25 0-1.7-1.2-2.85L35.6.15z"
                    id="FacNos002__Symbol_33_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2n}
                    d="M31.55 8.5q.85-.3 1.55-1 1.2-1.15 1.2-2.8 0-1.35-.8-2.35-.35-.15-.65-.3-15.5-4.1-31.35 0-.4.15-.75.35Q0 3.4 0 4.7q0 .35.05.7.05.45.25.85.3.6.95 1.25 1.15 1.1 2.9 1.1.6 0 1.1-.1Q6.8 8.25 7.9 7.4q.45-.4 1.3-1.3.2-.25.5-.25.25 0 .5.2.2.2.2.5.05.75.55 1.45v.05q.5.75 1.4 1.4 1.95 1.45 4.75 1.45t4.85-1.45q1.65-1.25 1.8-2.95.05-.3.25-.45.2-.2.5-.2t.5.25q.8.9 1.3 1.3 1.15.9 2.85 1.15.55.15 1.15.15.65 0 1.25-.2z"
                    id="FacNos002__Symbol_32_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#FacNos002__Symbol_33_0_Layer0_0_FILL"
                transform="translate(174.1 200.3)"
                id="FacNos002__col1n"
            />
            <use
                xlinkHref="#FacNos002__Symbol_32_0_Layer0_0_FILL"
                transform="translate(175.45 198.05)"
                id="FacNos002__col2n"
            />
        </g></g>
    )
}
export default FacNos002
